import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { useMemo } from "react";

import { Link } from "@transfr-inc/dashboard-components";

import { SupportCenterForm } from "@models/links";

export const SupportCenterButton = ({ className, onClick, appendUrl = "" }) => {
  // Resolve against the base so a path with or without a leading slash lands
  // under the support host without doubling the separator.
  const supportCenterUrl = useMemo(
    () => new URL(appendUrl, SupportCenterForm.url).href,
    [appendUrl]
  );

  return (
    <Link
      className={clsx("btn small", className)}
      href={supportCenterUrl}
      underline={false}
      onClick={onClick}
    >
      Support Center
      <FontAwesomeIcon icon={["far", "arrow-up-right-from-square"]} />
    </Link>
  );
};
